(function () {
  var TYPE_SPEED = 85;
  var DELETE_SPEED = 45;
  var PAUSE_FULL = 1400;
  var PAUSE_EMPTY = 500;

  function animate(el) {
    var text = el.getAttribute('placeholder') || '';
    if (!text) return;
    var i = 0;
    var deleting = false;

    function tick() {
      if (document.activeElement === el) {
        window.setTimeout(tick, 300);
        return;
      }
      if (!deleting) {
        i++;
        el.setAttribute('placeholder', text.slice(0, i));
        if (i >= text.length) {
          deleting = true;
          window.setTimeout(tick, PAUSE_FULL);
          return;
        }
        window.setTimeout(tick, TYPE_SPEED);
      } else {
        i--;
        el.setAttribute('placeholder', text.slice(0, i));
        if (i <= 0) {
          deleting = false;
          window.setTimeout(tick, PAUSE_EMPTY);
          return;
        }
        window.setTimeout(tick, DELETE_SPEED);
      }
    }

    tick();
  }

  function init() {
    document.querySelectorAll('[data-typewriter]').forEach(animate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
